<button
  extended
  mat-flat-button
  [color]="_color"
  [ngClass]="{
    'n-one-btn': _hasBorder,
    'n-one-selected': _selected,
    'n-one-theme-mode': _themeMode,
  }"
  (click)="onButtonClick()"
>
  <mat-icon
    class="material-icons"
    [ngClass]="{
      'n-one-btn-icon-colorful': _colorfulIcon,
    }"
    >{{ _icon }}</mat-icon
  >
  {{ _label }}
</button>
